<template>
  <span>
    <i class="el-icon-view scale-info" @click.stop="openInfo"></i>
    <InfoDialog
      :manualAttributeValueList="manualAttributeValueList"
      :dialogVisible.sync="infoDialog"
      :datailDatas="infoObj"
      :editable="editable"
      @updateModel="$emit('updateModel')"
    />
  </span>
</template>
<script>
import InfoDialog from './infoDialog.vue'
export default {
  components: {
    InfoDialog
  },
  props: {
    manualAttributeValueList: {
      type: Array,
      default: () => []
    },
    row: {
      type: Array,
      default: () => []
    },
    // 参数是否可编辑
    editable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      infoDialog: false,
      infoObj: []
    }
  },
  methods: {
    openInfo () {
      this.infoObj = this.row
      this.infoDialog = true
    }
  }
}
</script>
<style lang="scss">
.scale-info {
  // transform: scale(0);
  font-size: 16px;
  transition: all 0.3s cubic-bezier(0.22, 0.61, 0.36, 1);
  color: #1989fa;
  vertical-align: middle;
  cursor: pointer;
}
// &:hover .scale-info {
//   transform: scale(1);
// }
</style>
